import { gql } from '@apollo/client';

const CLINIC_RMA_SHIPMENT_REMINDER_MUTATION = gql`
  mutation clinicRmaShipmentReminder($ticketId: ID!, $isReminder: Boolean!) {
    clinicRmaShipmentReminder(ticketId: $ticketId, isReminder: $isReminder) {
      isSuccess
      message
    }
  }
`;

export default CLINIC_RMA_SHIPMENT_REMINDER_MUTATION;
